import React, { useState, useRef } from 'react'
import { MdKeyboardArrowLeft } from "react-icons/md";
import './form.css'
import smartfm from '../Assets/smartfm.png'
import DynamicDetailTable from './DynamicTableDetails';
import smartproup from '../Assets/smartproup.png'
import reach from '../Assets/reach.png'
import helpdesk from '../Assets/helpdesk.png'
import xceed from '../Assets/xceed.png'
import Modal from '@mui/material/Modal';
import { PiWarningCircleFill } from "react-icons/pi";




export default function LicensePurchase() {
  const [open, setOpen] = useState(false);

  const purchasedProducts = [
    { 'productLogo': reach, 'productName': "Reach", 'price': "100", 'quantity': 1, 'total': "100" },
    { 'productLogo': smartfm, 'productName': "Web", 'price': "100", 'quantity': 1, 'total': "100" },
    { 'productLogo': smartproup, 'productName': "Smart Proup", 'price': "100", 'quantity': 1, 'total': "100" }
  ]

  const grid = [
    { keyName: 'productLogo', displayName: 'Product Logo', type: 'img' },
    { keyName: 'productName', displayName: 'Product Name', type: 'text' },
    { keyName: 'price', displayName: 'Price', type: 'amount' },
    { keyName: 'quantity', displayName: 'Quantity', type: 'quantity' },
    { keyName: 'total', displayName: 'Total', type: 'amount' }
  ]


  const tryAnotherProducts = [
    { 'productLogo': helpdesk, 'productName': "Helpdesk", 'Description': 'SMART FM Lite is a complete web-based computer aided' },
    { 'productLogo': xceed, 'productName': "xceed", 'Description': 'SMART FM Lite is a complete web-based computer aided' },
  ]

  const tryAnotherGrid = [
    { keyName: 'productLogo', displayName: 'Product Logo', type: 'img' },
    { keyName: 'productName', displayName: 'Product Name', type: 'text' },
    { keyName: 'Description', displayName: 'Description', type: 'Description' },
  ]


  const handleClose = () => {

  }

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <div className='w-auto py-14 bg-slate-50 z-10 px-10 flex justify-center items-center rounded-md'>
          <div className='flex flex-col gap-8 justify-center items-center '>
            <PiWarningCircleFill className='text-[70px] rotate-180 text-[#21446F]' />
            <p className='text-[16px] max-w-[500px] text-center'>Your request has been initiated our team will contact you shortly. If anything you can contact them</p>
            <p className='text-[14px]'>(Email - sales@smartfm.com or Ph.No - 044 284 204)</p>
            <button className='w-auto px-4 py-1 bg-[#21446F] outline-none border-none rounded-md text-[14px] text-[#fff]' onClick={()=>{setOpen(false)}}>Ok</button>
          </div>
        </div>
      </Modal>
      <div className='w-full p-4 flex flex-col gap-3  overflow-y-auto' style={{ height: 'calc(100vh-100px)' }} >

        <div className='w-full flex justify-between items-center'>
          <MdKeyboardArrowLeft className='text-2xl ' />
          <button className='w-auto px-4 py-1 bg-[#21446F] outline-none border-none rounded-md text-[14px] text-[#fff]' onClick={() => { setOpen(true) }}>Proceed</button>
        </div>
        <p className='text-[#14181FCC] text-[16px] font-semibold'>Your License Details</p>
        <div className='box-shadow  w-full h-auto grid grid-cols-4 gap-3 p-3 bg-white rounded-lg '>


          <div className='flex justify-center'>
            <img src={smartfm} className='w-[150px]' alt="smartfm" />
          </div>


          <div className='flex justify-center items-center gap-2 text-[14px]'>
            <p className='font-semibold'>Product Name:</p>
            <p>SMARTFM Web</p>
          </div>


          <div className='flex justify-center items-center gap-2 text-[14px]'>
            <p className='font-semibold'>License Key:</p>
            <p>[xxxx xxx xxxx]</p>
          </div>


          <div className='flex justify-center items-center gap-2 text-[14px]'>
            <p className='font-semibold'>License Status:</p>
            <div className='flex items-center gap-2 text-[#45AC37]'>
              <div className='w-[10px] h-[10px] rounded-full bg-[#45AC37]'></div>
              Active
            </div>
          </div>

        </div>
        <p className='text-[#14181FCC] text-[16px] font-semibold'>Added Products and Quantity Details </p>
        <DynamicDetailTable data={purchasedProducts} grid={grid} />
        <p className='text-[#14181FCC] text-[16px] font-semibold'>Try Our Other Products </p>
        <DynamicDetailTable data={tryAnotherProducts} grid={tryAnotherGrid} AddBtn={true} />
      </div>
    </div>
  )
}
